// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__18zpy","sendOtp":"AuthorizeToLogin_sendOtp__3MiOm"};